import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Plus, Trash2 } from "lucide-react";

export const EMPTY_LINE = { description: "", category: "", quantity: 1, price: 0, itbis_applies: false, is_service: true };

// Líneas de gasto con concepto, categoría contable, cantidad, precio e indicadores.
export function ExpenseLines({ lines, setLines, categories, exento, docType }) {
  const upd = (i, patch) => setLines((a) => a.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const placeholder = docType === "E43" ? "Concepto (ej. Peaje autopista Duarte)" : "Concepto del gasto";
  return (
    <div className="space-y-2" data-testid="expense-lines">
      {lines.map((l, i) => (
        <div key={i} className="grid grid-cols-12 gap-2 items-center border border-border rounded-md p-2">
          <Input className="col-span-12 md:col-span-4 h-9" placeholder={placeholder} value={l.description}
            onChange={(e) => upd(i, { description: e.target.value })} data-testid={`expense-line-desc-${i}`} />
          <select className="col-span-6 md:col-span-3 h-9 rounded-md border border-input bg-transparent px-2 text-sm"
            value={l.category} onChange={(e) => upd(i, { category: e.target.value })} data-testid={`expense-line-cat-${i}`}>
            <option value="">Otros gastos</option>
            {categories.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
          </select>
          <Input type="number" min="0" step="1" className="col-span-2 md:col-span-1 h-9 font-mono" value={l.quantity}
            onChange={(e) => upd(i, { quantity: e.target.value })} data-testid={`expense-line-qty-${i}`} />
          <Input type="number" min="0" step="0.01" className="col-span-4 md:col-span-2 h-9 font-mono" value={l.price}
            onChange={(e) => upd(i, { price: e.target.value })} data-testid={`expense-line-price-${i}`} />
          <div className="col-span-10 md:col-span-1 flex flex-col gap-1.5 text-xs">
            {!exento && (
              <label className="flex items-center gap-1"><Checkbox checked={l.itbis_applies} onCheckedChange={(v) => upd(i, { itbis_applies: !!v })} data-testid={`expense-line-itbis-${i}`} />ITBIS</label>
            )}
            {docType !== "E47" && docType !== "E43" && (
              <label className="flex items-center gap-1"><Checkbox checked={l.is_service} onCheckedChange={(v) => upd(i, { is_service: !!v })} data-testid={`expense-line-service-${i}`} />Servicio</label>
            )}
          </div>
          <Button size="icon" variant="ghost" className="col-span-2 md:col-span-1" disabled={lines.length === 1}
            onClick={() => setLines((a) => a.filter((_, j) => j !== i))} data-testid={`expense-line-remove-${i}`}>
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      ))}
      <Button variant="outline" size="sm" onClick={() => setLines((a) => [...a, { ...EMPTY_LINE }])} data-testid="expense-add-line">
        <Plus className="w-4 h-4 mr-1" /> Agregar línea
      </Button>
    </div>
  );
}
